'use client';

import { useCallback } from 'react';
import { useStore } from '@/store/store';
import { POPUPS } from '@/app/components/popup/constants';
import { getBiggestWinData } from '@/logic/page-config/biggest-win/biggest-win';

export const useBiggestWinPopup = () => {
    const queuePopup = useStore((s) => s.popup.queuePopup);
    const updatePopupParams = useStore((s) => s.popup.updatePopupParams);
    const activePopupType = useStore((s) => s.popup.activePopup?.type);

    const showBiggestWinPopup = useCallback(
        async (isHighlighted?: boolean) => {
            if (activePopupType === POPUPS.BIGGEST_WIN) {
                return;
            }

            queuePopup({
                type: POPUPS.BIGGEST_WIN,
                params: {
                    isLoading: true,
                    isHighlighted: isHighlighted ?? false
                }
            });

            // Get the updated activePopup id after queuePopup updates the store synchronously
            // We use getState() here because the hook's activePopup won't update until next render
            const updatedActivePopup = useStore.getState().popup.activePopup;
            const popupId = updatedActivePopup?.id;

            if (!popupId) {
                return;
            }

            (async () => {
                try {
                    const biggestWinData = await getBiggestWinData();

                    if (!biggestWinData) {
                        updatePopupParams(popupId, {
                            isLoading: false
                        });
                        return;
                    }

                    updatePopupParams(popupId, {
                        isLoading: false,
                        tileData: biggestWinData.tileData,
                        stake_amount: biggestWinData.stake_amount,
                        win_amount: biggestWinData.win_amount,
                        multiplier: biggestWinData.multiplier,
                        rgLink: biggestWinData.rgLink,
                        rgLogo: biggestWinData.rgLogo,
                        confettiAnimationUrl: biggestWinData.confettiAnimationUrl
                    });
                } catch {
                    updatePopupParams(popupId, {
                        isLoading: false
                    });
                }
            })();
        },
        [queuePopup, updatePopupParams, activePopupType]
    );

    return showBiggestWinPopup;
};
